import Type from './Group';

export default Type;
